import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  Folio:String = "";
  NumeroOrden:String = "";
  DatosOrden = [];
  Ok:boolean = false;
  constructor(private router:Router) {
    this.router.navigate(['vista']);
  }
  ngOnInit() {
  }
}
